interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function getPageItems(page: number, totalPages: number): (number | "gap")[] {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }
  const items: (number | "gap")[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);

  if (start > 2) items.push("gap");
  for (let i = start; i <= end; i += 1) items.push(i);
  if (end < totalPages - 1) items.push("gap");
  items.push(totalPages);
  return items;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-9 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-700 px-3 text-xs text-foreground-300 transition-colors hover:border-primary-600 hover:text-primary-200 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-700 disabled:hover:text-foreground-300"
      >
        <i className="ri-arrow-left-s-line text-sm" />
        上一页
      </button>

      {getPageItems(page, totalPages).map((item, index) =>
        item === "gap" ? (
          <span key={`gap-${index}`} className="px-1 text-xs text-foreground-600">
            ···
          </span>
        ) : (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            aria-current={item === page ? "page" : undefined}
            className={`h-9 w-9 cursor-pointer rounded-md border text-xs tabular-nums transition-colors ${
              item === page
                ? "border-primary-500 bg-primary-600 text-background-50"
                : "border-background-700 text-foreground-300 hover:border-primary-600 hover:text-primary-200"
            }`}
          >
            {item}
          </button>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex h-9 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-700 px-3 text-xs text-foreground-300 transition-colors hover:border-primary-600 hover:text-primary-200 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-700 disabled:hover:text-foreground-300"
      >
        下一页
        <i className="ri-arrow-right-s-line text-sm" />
      </button>
    </nav>
  );
}